/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1AccountState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_ACCOUNT_STATE_ENTITY_NAME = 'ixf.accounting.v1.Account';
export const ixfAccountingV1AccountStateEntity = new schema.Entity<IxfAccountingV1AccountState>(IXF_ACCOUNTING_V1_ACCOUNT_STATE_ENTITY_NAME, {}, { idAttribute: 'accountId' });

